/**
 * Base85 encoder with XML-safe alphabet (modified Z85).
 * Encodes 4 bytes into 5 characters. Used for CIDRA tokens.
 *
 * NOT compatible with standard Z85 - replaces : & < > with , ; _ ~ for XML safety.
 */

const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ.-,+=^!/*?;_~()[]{}@%$#';

/**
 * Encodes a byte array (Uint8Array or Buffer) to Base85 string.
 * @param {Uint8Array|Buffer} data - byte array (length must be divisible by 4)
 * @returns {string} encoded string
 */
export function base85Encode(data) {
  if (!data) {
    throw new Error('Input data cannot be null');
  }

  if (data.length % 4 !== 0) {
    throw new Error(`Input length must be divisible by 4, got ${data.length} bytes`);
  }

  const numChunks = data.length / 4;
  let result = '';

  for (let i = 0; i < numChunks; i++) {
    const offset = i * 4;

    // 4 bytes to big-endian 32-bit integer
    // Use >>> 0 to convert to unsigned 32-bit integer
    const value = (
      ( (data[offset] & 0xff) << 24) |
      ( (data[offset + 1] & 0xff) << 16) |
      ( (data[offset + 2] & 0xff) << 8) |
      (data[offset + 3] & 0xff)
    ) >>> 0;

    let v = value;
    const encoded = new Array(5);
    for (let j = 4; j >= 0; j--) {
      encoded[j] = ALPHABET[v % 85];
      v = Math.floor(v / 85);
    }

    result += encoded.join('');
  }

  return result;
}

